import React from 'react';
import '../../../styles/PnrFooter.css';

type contentItemProps = {
  text: string;
  onClickUrl: string;
  id: string;
};

type headingProps = {
  heading: [contentItemProps];
};

function getFooterItem(heading: headingProps) {
  const footerContent = Object.keys(heading).map((content) => {
    return (
      <div className="appendBottom15" key={heading[content]}>
        {heading[content].map((item: contentItemProps) => (
          <span className="footerItem">
            <a href={item.onClickUrl} className="footerLink" key={item.id}>
              {item.text}
            </a>
          </span>
        ))}
      </div>
    );
  });
  return footerContent;
}

function PnrFooter() {
  const footer_data = require('../constants/pnr-footer-data.json');
  const footerItems = Object.keys(footer_data).map((heading) => {
    return (
      <div key={footer_data[heading]}>
        <p className="footerHeading"> {heading} </p>
        {getFooterItem(footer_data[heading])}
      </div>
    );
  });

  return (
    <div className="footerContainer">
      <div className="contentWpr">{footerItems}</div>
    </div>
  );
}

export default PnrFooter;
